import { reactToAngularComponent } from '@kathondvla/react-shared-components/src/helpers/angularReactHelper';
import app from '../../app/app';
import CurriculumSelector from '../../components/npViewOptions/reactCurriculumSelector/CurriculumSelector';
import StoreProvider from '../../reduxLoop/StoreProvider';

app.component(
  'reactCurriculumSelector',
  reactToAngularComponent(CurriculumSelector, StoreProvider)
);
